import { createBrowserRouter, Outlet } from 'react-router-dom'
import AppSuspense from '@/core/components/appSuspense/AppSuspense.tsx'
import { lazy } from 'react'
import { LoginGuard } from '@/core/guards/LoginGuard.tsx'
import { frontPaths } from '@/config/frontPaths.ts'
import { LogoutGuard } from '@/core/guards/LogoutGuard.tsx'
import NotFoundPage from '@/pages/notFound/NotFoundPage.tsx'
import HOME_ROUTES from '@/router/home/home.routes.tsx'
import { SECURITY_ROUTES } from '@/router/security/security.routes.tsx'
import UTILITIES_ROUTES from '@/router/utilities/utilities.routes.tsx'
import WeppaLoader from '@/core/components/weppaLoader/WeppaLoader.tsx'
import SALES_ROUTES from '@/router/sales/sales.routes.tsx'
import SETTINGS_ROUTES from '@/router/settings/settings.routes.tsx'
import ALLIES_ROUTES from '@/router/allies/allies.routes.tsx'
import SUPPORT_ROUTES from '@/router/support/support.routes.tsx'
import COLLECTIONS_ROUTES from '@/router/collections/collections.routes.tsx'
import INVENTORIES_ROUTES from '@/router/inventory/inventories.routes.tsx'
import TEACHING_ROUTES from '@/router/teaching/teaching.routes.tsx'
import REPORT_ROUTES from '@/router/reports/reports.routes.tsx'
import NOTIFICATION_ROUTES from '@/router/notifications/notifications.routes.tsx'
import SERVICES_ROUTES from '@/router/services/services.routes.tsx'
import INSURERS_ROUTES from '@/router/insurers/insurers.routes.tsx'
import MARKETPLACE_ROUTES from '@/router/marketplace/marketplace.routes.tsx'
import DRAW_ROUTES from '@/router/draw/draw.routes.tsx'

const ErrorPage = lazy(() => import('../pages/errors/ErrorPage.tsx'))
const App = lazy(() => import('../App.tsx'))

const router = createBrowserRouter([
  {
    path: '/',
    element: <AppSuspense loader={<WeppaLoader />} />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: '',
        element: <AppSuspense loader={<WeppaLoader />} />,
        children: [
          {
            path: '',
            element: (
              <LoginGuard ifNotLoggedTo={frontPaths.security.login}>
                <App />
              </LoginGuard>
            ),
            children: [
              ...HOME_ROUTES,
              ...SETTINGS_ROUTES,
              ...SALES_ROUTES,
              ...ALLIES_ROUTES,
              ...SUPPORT_ROUTES,
              ...COLLECTIONS_ROUTES,
              ...INVENTORIES_ROUTES,
              ...TEACHING_ROUTES,
              ...REPORT_ROUTES,
              ...NOTIFICATION_ROUTES,
              ...SERVICES_ROUTES,
              ...INSURERS_ROUTES,
              ...MARKETPLACE_ROUTES,
              ...DRAW_ROUTES
            ]
          }
        ]
      },
      {
        path: frontPaths.security.index,
        element: (
          <LogoutGuard ifLoggedTo={frontPaths.home}>
            <Outlet />
          </LogoutGuard>
        ),
        children: [...SECURITY_ROUTES]
      },
      {
        path: '',
        element: <Outlet />,
        children: [...UTILITIES_ROUTES]
      }
    ]
  },
  {
    path: '*',
    element: (
      <LoginGuard ifNotLoggedTo={frontPaths.security.login}>
        <NotFoundPage />
      </LoginGuard>
    )
  }
])

export default router
